export const ALL_GENRES = 'All'

export const MIX_SORT_OPTIONS = [
    { key: 'recentlyAdded', label: 'Recently added' },
    { key: 'releaseDate', label: 'Release date' },
    { key: 'artistName', label: 'Artist name' },
    { key: 'showName', label: 'Show name' },
]

export const ARTIST_SORT_OPTIONS = [
    { key: 'recentlyAdded', label: 'Recently added' },
    { key: 'name', label: 'Name' },
]

const normalize = value => (value || '').toString().toLowerCase()

// numeric collation keeps "… 2" ahead of "… 10" in numbered titles
const collate = (a, b) => a.localeCompare(b, undefined, { numeric: true })

// missing values sort LAST (a bare localeCompare would sort the empty string first)
const compareNormalized = (a, b) => {
    if (!a && !b) return 0
    if (!a) return 1
    if (!b) return -1
    return collate(a, b)
}

export function deriveGenrePills(mixes) {
    const names = new Set()
    mixes.forEach(mix => (mix.genre || []).forEach(name => names.add(name)))
    return [...names].sort(collate)
}

export function filterMixesByGenre(mixes, genre) {
    if (!genre || genre === ALL_GENRES) return mixes
    return mixes.filter(mix => (mix.genre || []).includes(genre))
}

export function sortMixes(mixes, key) {
    const sorted = [...mixes]
    if (key === 'releaseDate') {
        return sorted.sort(
            (a, b) => new Date(b.episode?.air_start || 0) - new Date(a.episode?.air_start || 0)
        )
    }
    if (key === 'artistName') {
        return sorted.sort((a, b) => compareNormalized(normalize(a.artist?.title), normalize(b.artist?.title)))
    }
    if (key === 'showName') {
        return sorted.sort((a, b) => compareNormalized(normalize(a.show?.title), normalize(b.show?.title)))
    }
    return sorted // 'recentlyAdded' — server order is newest-favorite-first; do not re-sort
}

export function sortArtists(artists, key) {
    if (key !== 'name') return [...artists]
    return [...artists].sort((a, b) => compareNormalized(normalize(a.title), normalize(b.title)))
}

export function searchLibrary({ mixes = [], artists = [], shows = [], genres = [] }, query) {
    const q = normalize(query).trim()
    if (!q) return { artists: [], mixes: [], shows: [], genres: [], total: 0 }

    const matchedMixes = mixes.filter(
        mix =>
            normalize(mix.title).includes(q) ||
            normalize(mix.artist?.title).includes(q) ||
            (mix.genre || []).some(name => normalize(name).includes(q))
    )
    const matchedArtists = artists.filter(artist => normalize(artist.title).includes(q))
    const matchedShows = shows.filter(show => normalize(show.title).includes(q))
    const matchedGenres = genres.filter(genre => normalize(genre.name).includes(q))

    return {
        artists: matchedArtists,
        mixes: matchedMixes,
        shows: matchedShows,
        genres: matchedGenres,
        total: matchedArtists.length + matchedMixes.length + matchedShows.length + matchedGenres.length,
    }
}
